"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseWalletSelectorTransactions = void 0;
const core_1 = require("@multi-transaction/core");
function parseWalletSelectorTransactions(mTransaction) {
    return mTransaction.toTransactions().map((transaction) => parseWalletSelectorTransaction(transaction));
}
exports.parseWalletSelectorTransactions = parseWalletSelectorTransactions;
function parseWalletSelectorTransaction(transaction) {
    const { signerId, receiverId, actions } = transaction;
    return {
        signerId,
        receiverId,
        actions: actions.map((action) => parseWalletSelectorAction(action)),
    };
}
function parseWalletSelectorAction(action) {
    if (action.type === 'CreateAccount' ||
        action.type === 'DeleteAccount' ||
        action.type === 'AddKey' ||
        action.type === 'DeleteKey' ||
        action.type === 'DeployContract') {
        return action;
    }
    if (action.type === 'Stake') {
        const { amount, publicKey } = action.params;
        return {
            type: action.type,
            params: {
                stake: amount,
                publicKey,
            },
        };
    }
    if (action.type === 'FunctionCall') {
        const { methodName, args, gas, attachedDeposit } = action.params;
        return {
            type: action.type,
            params: {
                methodName,
                args,
                gas,
                deposit: attachedDeposit,
            },
        };
    }
    if (action.type === 'Transfer') {
        const { amount } = action.params;
        return {
            type: action.type,
            params: {
                deposit: amount,
            },
        };
    }
    throw new core_1.UnreachableError();
}
//# sourceMappingURL=utils.js.map